import { useState } from "react";
import { useToast } from "@chakra-ui/react";
import {
  Button,
  Input,
  Box,
  Card,
  FormLabel,
  Stack,
  Heading,
  InputLeftAddon,
  InputGroup,
  ButtonGroup,
} from "@chakra-ui/react";
import "react-phone-number-input/style.css";
import { keyframes } from "@emotion/react"
import { registerAction } from "../Store/index";
import { useDispatch, useSelector } from "react-redux";
import { BASE_URL } from "../../../constants/defaultValues";
import axios from "axios";
import InputMask from "react-input-mask";

const LoginForm2 = ({ nextStep, prevStep }) => {
  const dispatch = useDispatch();
  const toast = useToast();
  const registerData = useSelector((state) => state.register);
  const [showDetailForm, seTshowDetailForm] = useState(
    registerData.showDetailForm
  );
  const [clickedSelect, setClickedSelect] = useState(
    registerData.clickedSelect
  );
  const [clickedOption, setClickOption] = useState(false);
  const [newphoneOptions, setNewphoneOptions] = useState(
    registerData.newnumbersoptions
  );
  const [formdata, setFormdata] = useState({
    accountname: registerData.accountname,
    currentnumber: registerData.currentnumber,
    newnumber: registerData.newnumber,
    street: registerData.street,
    postalcode: registerData.postalcode,
    city: registerData.city,
    isocountry: registerData.isocountry,
    region: registerData.region,
  });
  const [value, setValue] = useState();

  const [errors, setErrors] = useState({
    accountname: "",
    currentnumber: "",
    newnumber: "",
    street: "",
    postalcode: "",
    city: "",
    isocountry: "US",
    region: "",
  });

  const getNumber = (inputString) => {
    // Use regular expression to find all numbers in the string and join them into one string
    const numbersArray = inputString.match(/\d+/g);
    const allNumbersAsString = numbersArray ? numbersArray.join("") : "";
    return "+1" + allNumbersAsString;
  };

  const checkValiditiy = async () => {
    setFormdata({ ...formdata, currentnumber: formdata.currentnumber });
    if (formdata.currentnumber) {
      const result = await axios.post(
        `${BASE_URL}/api/checkHostedNumberEligibility`,
        {
          phoneNumber: getNumber(formdata.currentnumber),
        }
      );
      if (
        result?.data?.error == "true" ||
        result?.data?.status == "INELIGIBLE"
      ) {
        toast({
          position: "top-right",
          title: result?.data?.status,
          description: "Number is ineligible.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          position: "top-right",
          title: "Number Eligible",
          description: "Number is Eligible.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        seTshowDetailForm(true);
        setClickOption(false);
      }
    } else {
      setErrors({
        ...errors,
        currentnumber: "This field is required.",
      });
    }
  };

  const swashin = keyframes`
      0% {
        opacity: 0;
        -webkit-transform-origin: 50% 50%;
        transform-origin: 50% 50%;
        -webkit-transform: scale(0, 0);
        transform: scale(0, 0);
      }
    
      90% {
        opacity: 1;
        -webkit-transform-origin: 50% 50%;
        transform-origin: 50% 50%;
        -webkit-transform: scale(0.9, 0.9);
        transform: scale(0.9, 0.9);
      }
    
      100% {
        opacity: 1;
        -webkit-transform-origin: 50% 50%;
        transform-origin: 50% 50%;
        -webkit-transform: scale(1, 1);
        transform: scale(1, 1);
      }
    `;

  const handleChange = (e) => {
    setFormdata({ ...formdata, [e.target.name]: e.target.value });
    setErrors({
      accountname: "",
      currentnumber: "",
      newnumber: "",
      street: "",
      postalcode: "",
      city: "",
      isocountry: "",
      region: "",
    });
  };

  const handlerNewnumberOptionChange = (e) => {
    if (e.target.value.length == 3)
      axios
        .post(
          `${BASE_URL}/api/searchNumberFromTwilio?query=${e.target.value}&search_type=1`
        )
        .then((res) => {
          {
            setNewphoneOptions(res.data.data);
          }
        })
        .catch((err) => {
          setNewphoneOptions([]);
        });
    else setNewphoneOptions([]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formdata.accountname && !clickedSelect && !showDetailForm) {
      setErrors({
        ...errors,
        accountname: "Account name is required.",
        currentnumber: "This field is required.",
      });
      return;
    }
    if (!clickedSelect && !showDetailForm) {
      toast({
        position: "top-right",
        title: "Number.",
        description: "Select or buy the number.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (clickedSelect) {
      if (!formdata.accountname && !formdata.newnumber) {
        setErrors({
          ...errors,
          accountname: "Account name is required.",
          newnumber: "This field is required.",
        });
        return;
      } else if (!formdata.accountname) {
        setErrors({
          ...errors,
          accountname: "Account name is required.",
        });
        return;
      } else if (!formdata.newnumber) {
        setErrors({
          ...errors,
          newnumber: "This field is required.",
        });
        return;
      }
      const checkNewnumberValidity = newphoneOptions.find((num) => {
        if (
          `(${num.shortPhone.slice(0, 3)}) ${num.shortPhone.slice(
            3,
            6
          )}-${num.shortPhone.slice(6, 10)}` === formdata.newnumber
        ) {
          return true;
        }
      });
      if (!checkNewnumberValidity) {
        setErrors({
          ...errors,
          newnumber: "Number not exist",
        });
        return;
      }
    }
    if (showDetailForm) {
      if (
        !formdata.accountname &&
        !formdata.currentnumber &&
        !formdata.street &&
        !formdata.city &&
        !formdata.postalcode &&
        !formdata.region &&
        !formdata.isocountry
      ) {
        setErrors({
          ...errors,
          accountname: "Account name is required.",
          currentnumber: "This field is required.",
          street: "Street is required.",
          city: "City is required.",
          isocountry: "IsoCountry is required.",
          region: "Region is required.",
          postalcode: "Zip Code is required",
        });
        return;
      } else if (!formdata.accountname) {
        setErrors({
          ...errors,
          accountname: "Account name is required.",
        });
        return;
      } else if (!formdata.currentnumber) {
        setErrors({
          ...errors,
          currentnumber: "This field is required.",
        });
        return;
      } else if (!formdata.street) {
        setErrors({
          ...errors,
          street: "Street is required.",
        });
        return;
      } else if (!formdata.region) {
        setErrors({
          ...errors,
          region: "Region is required.",
        });
        return;
        // } else if (!formdata.isocountry) {
        //   setErrors({
        //     ...errors,
        //     isocountry: "Require",
        //   });
        //   return;
        // } else if (!formdata.city) {
        setErrors({
          ...errors,
          city: "Require",
        });
        return;
      } else if (!formdata.postalcode) {
        setErrors({
          ...errors,
          postalcode: "Zip code is required.",
        });
        return;
      }
    }
    if (showDetailForm) {
      dispatch(registerAction.showDetailFormHandler());
    } else {
      dispatch(registerAction.clickedSelectHandler());
    }
    dispatch(registerAction.form2(formdata));
    dispatch(registerAction.addnewnumberoptions(newphoneOptions));
    nextStep();
  };

  const formattedValue = () => {
    if (formdata.currentnumber.length <= 3) {
      return `(${formdata.currentnumber}`;
    } else if (formdata.currentnumber.length <= 6) {
      return `(${formdata.currentnumber.slice(
        0,
        3
      )}) ${formdata.currentnumber.slice(3)}`;
    } else {
      return `(${formdata.currentnumber.slice(
        0,
        3
      )}) ${formdata.currentnumber.slice(
        3,
        6
      )} - ${formdata.currentnumber.slice(6, 10)}`;
    }
  };
  const getMask = () => {
    if (formdata.currentnumber && formdata.currentnumber.length >= 3) {
      return "(999) 999 - 9999";
    }
    return "";
  };

  return (
    <Box display="flex" flexDir="column" alignItems="center"   w="100%">
      <Box px="20px" mb="15px" mt="10px">
        <Heading textAlign="center">
          {!showDetailForm
            ? "Let's decide on a phone number"
            : "Almost there, just a few more details "}
        </Heading>
      </Box>

      <Card px="20px" pt="25px" w={{ base: "90%", md: "70%", lg: "60%" }}>
        <form onSubmit={handleSubmit}>
          <Box mb="10px" >
            <FormLabel fontSize={{ base: "sm", md: "md" }}>
              What would you like to name your account?
            </FormLabel>

            <Input
              type="text"
              id="accountname"
              name="accountname"
              onChange={handleChange}
              value={formdata.accountname}
              borderColor="gray"
              borderWidth="1px"
              mx="auto"
              placeholder="Enter your account name"
            />
            <div style={{ color: "red" }}>
              {errors.accountname && errors.accountname}
            </div>
          </Box>
          <Box display="flex" gap="15px" flexDir="column">
            <Box display="flex" gap="15px" alignItems="end">
              <Box flex="1">
                <FormLabel fontSize={{ base: "sm", md: "md" }}>
                  Do you want texts to come from your landline number? Let's
                  make sure that number works with our system.
                </FormLabel>
                <InputGroup>
                  <InputLeftAddon children="+1" />

                  <InputMask
                    style={{
                      width: "100%",
                      border: "1px solid black",
                      paddingLeft: "14px",
                    }}
                    mask={getMask()}
                    maskChar={null}
                    value={formdata.currentnumber}
                    onChange={handleChange}
                    name="currentnumber"
                    placeholder="Enter your landline number"
                  />
                  {/* <Input
                    mx="auto"
                    placeholder="Enter your current number"
                    type="text"
                    id="currentnumber"
                    name="currentnumber"
                    onChange={handleChange}
                    value={formdata.currentnumber}
                    borderColor="gray"
                    borderWidth="1px"
                    disabled={clickedSelect || showDetailForm}
                  /> */}
                </InputGroup>
              </Box>
              <Box>
                <Button
                  isDisabled={clickedSelect || showDetailForm}
                  onClick={() => {
                    setFormdata({
                      ...formdata,
                      newnumber: "",
                    });
                    checkValiditiy();
                  }}
                  bg="#576CD1"
                  color="white"
                  _hover={{ bg: "#576CD1" }}
                >
                  Check
                </Button>
              </Box>
            </Box>
            <div style={{ color: "red" }}>
              {errors.currentnumber && errors.currentnumber}
            </div>
            <Box display="flex" gap="15px" alignItems="end">
              <Box position="relative" flex="1">
                <FormLabel fontSize={{ base: "sm", md: "md" }}>
                  Would you rather not use your landline number or is our system
                  saying your number is ineligible? No problem, you can choose a
                  new one here.
                </FormLabel>
                <InputGroup>
                  <InputLeftAddon children="+1" />
                  <Input
                    mx="auto"
                    placeholder="Enter the 3 digit area code of a number you want to use"
                    type="text"
                    id="newnumber"
                    name="newnumber"
                    onChange={(e) => {
                      handleChange(e);
                      handlerNewnumberOptionChange(e);
                      setClickOption(true);
                    }}
                    value={formdata.newnumber}
                    borderColor="gray"
                    borderWidth="1px"
                    disabled={showDetailForm}
                  />
                </InputGroup>
                {clickedOption && (
                  <Box
                    position="absolute"
                    w="100%"
                    zIndex="50"
                    bg="white"
                    maxH="150px"
                    overflow="scroll"
                  >
                    {newphoneOptions &&
                      newphoneOptions.map((num) => {
                        return (
                          <Box
                            key={num.shortPhone}
                            onClick={async () => {
                              setFormdata({
                                ...formdata,
                                newnumber: `(${num.shortPhone.slice(
                                  0,
                                  3
                                )}) ${num.shortPhone.slice(
                                  3,
                                  6
                                )}-${num.shortPhone.slice(6, 10)}`,
                              });
                              setClickOption(false);
                              setClickedSelect(true);
                            }}
                            py="10px"
                            px="5px"
                            cursor="pointer"
                            _hover={{
                              bg: "gray.300",
                            }}
                          >{`(${num.shortPhone.slice(
                            0,
                            3
                          )}) ${num.shortPhone.slice(
                            3,
                            6
                          )}-${num.shortPhone.slice(6, 10)}`}</Box>
                        );
                      })}
                  </Box>
                )}
              </Box>
            </Box>
            <div style={{ color: "red" }}>
              {errors.newnumber && errors.newnumber}
            </div>
          </Box>
          {showDetailForm && (
            <Box animation={`${swashin} 0.5s `} mt="15px">
              <Stack direction="row" spacing="15px">
                <Box flex="3">
                  <FormLabel>Street address</FormLabel>
                  <Input
                    placeholder="Enter street address"
                    type="text"
                    id="street"
                    name="street"
                    onChange={handleChange}
                    value={formdata.street}
                    borderColor="gray"
                    borderWidth="1px"
                  />
                  <div style={{ color: "red" }}>
                    {errors.street && errors.street}
                  </div>
                </Box>
                <Box flex="1.3">
                  <FormLabel>City</FormLabel>
                  <Input
                    type="text"
                    id="city"
                    name="city"
                    onChange={handleChange}
                    value={formdata.city}
                    borderColor="gray"
                    borderWidth="1px"
                    placeholder="Enter city"
                  />
                  <div style={{ color: "red" }}>
                    {errors.city && errors.city}
                  </div>
                </Box>
              </Stack>
              <Stack mt="10px" direction="row" spacing="15px">
                <Box flex="3">
                  <FormLabel>State</FormLabel>
                  <Input
                    type="text"
                    id="region"
                    name="region"
                    onChange={handleChange}
                    value={formdata.region}
                    borderColor="gray"
                    borderWidth="1px"
                    placeholder="Enter state abbreviation"
                  />
                  <div style={{ color: "red" }}>
                    {errors.region && errors.region}
                  </div>
                </Box>
                <Box flex="1.3">
                  <FormLabel whiteSpace="nowrap">Zip code</FormLabel>
                  <Input
                    type="text"
                    id="postalcode"
                    name="postalcode"
                    onChange={handleChange}
                    value={formdata.postalcode}
                    borderColor="gray"
                    borderWidth="1px"
                    placeholder="Enter zip code"
                  />
                  <div style={{ color: "red" }}>
                    {errors.postalcode && errors.postalcode}
                  </div>
                </Box>
              </Stack>
              {/* <Box mt="10px">
                <FormLabel>ISO Country</FormLabel>
                <Input
                  type="text"
                  id="isocountry"
                  name="isocountry"
                  onChange={handleChange}
                  value={formdata.isocountry}
                  borderColor="gray"
                  borderWidth="1px"
                  placeholder="Iso Country"
                />
                <div style={{ color: "red" }}>
                  {errors.isocountry && errors.isocountry}
                </div>
              </Box> */}
            </Box>
          )}
          <ButtonGroup display="flex" gap="20px">
            <Button
              mt="20px"
              w="100%"
              mb="20px"
              bg="#576CD1"
              color="white"
              type="submit"
              _hover={{ bg: "#576CD1" }}
              onClick={prevStep}
            >
              Previous
            </Button>
            <Button
              mt="20px"
              w="100%"
              mb="20px"
              bg="#576CD1"
              color="white"
              type="submit"
              _hover={{ bg: "#576CD1" }}
              // onClick={nextStep}
            >
              Next
            </Button>
          </ButtonGroup>
        </form>
      </Card>
    </Box>
  );
};

export default LoginForm2;
